module.exports = __webpack_public_path__ + "static/media/circule1.69065d58.png";